import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
    dataview_root: {
        display: 'flex',
        flexGrow: 1,
        '& > *': {
            margin: theme.spacing(2)
        },
    },
    accordion_root: {
        width: '100%',
        display: 'block',
        marginBottom: theme.spacing(1)
    },
    courses_root: {
        width: '100%',
        height: '500px',
        overflowX: 'auto',
        overflowY: 'auto',
        border: `solid #eee 1px`,
        borderRadius: '3px',
        padding: '10px',
        marginBottom: theme.spacing(3),
    },
    admins_root: {
        width: '100%',
        height: '500px',
        overflowX: 'auto',
        overflowY: 'auto',
        border: `solid #eee 1px`,
        borderRadius: '3px',
        padding: '10px',
        marginBottom: theme.spacing(3),
    },
    classes_root: {
        width: '100%',
        overflowX: 'auto',
        overflowY: 'auto',
        border: `solid #eee 1px`,
        borderRadius: '3px',
        padding: '10px',
        marginBottom: theme.spacing(3),
    },
    clickable: {
        cursor: 'pointer'
    },
    mt2: {
        marginTop: theme.spacing(2),
    },
    mt10: {
        marginTop: theme.spacing(10),
    },
    mlr1: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1)
    },
    loaderContainer: {
        display: 'flex',
        flexDirection: 'column' as const,
        alignItems: 'center',
    },
    modal_root: {
        flexGrow: 1,
        maxWidth: 752,
    },
    title: {
        margin: theme.spacing(4, 0, 2),
    },
    paper: {
        position: 'absolute',
        width: "80%",
        height: 650,
        overflowY: "auto",
        overflowX: "auto",
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
    usersTable: {
        display: 'inline-block',
        width: '50%'
    },
    recordCell: {
      paddingRight: '5px'
    },
    preline: {
        whiteSpace: 'pre-line'
    },
    schoolName: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '25%',
        flexShrink: 0,
        alignItems: 'left'
    },
    schoolAcademicYear: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '25%',
        flexShrink: 0,
        alignItems: 'center'
    },
    schoolStatus: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '25%',
        flexShrink: 0,
        textAlign: 'center'
    },
    schoolCourses: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '25%',
        flexShrink: 0,
        textAlign: 'right'
    },
    siteAdminsTitle: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: '50%',
      flexShrink: 0,
      alignItems: 'left'
    },
    siteAdminsCount: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: '50%',
      flexShrink: 0,
      textAlign: 'right'
    },
    hierarchy_root: {
        width: '100%',
        display: 'block'
    },
});

export const getUserDetailsStyles = (theme: Theme, topOffset?: number) => ({
    clickable: {
        cursor: "pointer",
    },
    dynamicMargin: {
        position: "relative" as const,
        top: `${Math.floor(
            topOffset && topOffset - 200 > 0
                ? topOffset - 200
                : 0
        )}px`,
    },
    loaderContainer: {
        display: "flex",
        flexDirection: "column" as const,
        alignItems: "center",
    },
});
